export const SET_ACCESS_PATH_REQUEST = '@routeAccess/SET_ACCESS_PATH_REQUEST';
export const SET_ACCESS_PATH_SUCCESS = '@routeAccess/SET_ACCESS_PATH_SUCCESS';
export const SET_ACCESS_PATH_FAILURE = '@routeAccess/SET_ACCESS_PATH_FAILURE';

export const RESET = '@routeAccess/RESET';
export const RESET_PATH = '@routeAccess/RESET_PATH';
